import KTag from 'app/components/UI-Elements/DataDisplay/KTag'
import * as React from 'react'

type Props = {
  member: IRental
}

const statusColor: { [key in IRentalStatus]: string } = {
  quoted: 'green',
  missing_requirements: 'red',
  active: 'green',
  order_won: 'green',
  finalizing: 'blue',
  finalized: 'default',
  canceled: 'default',
  quote_in_preparation: 'blue',
  open_invoice: 'blue'
}

const RentalStatusTag: React.FC<Props> = ({ member }) => (
  <KTag text={member.status_info.title || '-'} color={statusColor[member.status]} />
)

export default RentalStatusTag
